/**
 * Shared Session Selector Component
 * Dropdown for selecting sessions with consistent formatting
 */

import React from 'react';
import { Session } from '../lib/types';
import { siteLabel } from '../lib/siteTree';

const EMPTY_SITE_NAMES = new Map<number, string>();

interface SessionSelectorProps {
  sessions: Session[];
  selectedSessionId: number | null;
  onSelect: (sessionId: number | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  siteNames?: Map<number, string>;
}

export const SessionSelector: React.FC<SessionSelectorProps> = ({
  sessions,
  selectedSessionId,
  onSelect,
  placeholder = 'Select a session...',
  className = '',
  disabled = false,
  siteNames = EMPTY_SITE_NAMES,
}) => {
  return (
    <select
      value={selectedSessionId || ''}
      onChange={(e) => onSelect(e.target.value ? Number(e.target.value) : null)}
      className={`px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {sessions.map((session) => {
        const status = session.monitored ? '[ACTIVE]' : '[ENDED]';
        const startDate = session.sessionStartTime
          ? new Date(session.sessionStartTime).toLocaleDateString()
          : 'Unknown';
        const clipName = session.clipName || session.clipAddress || 'Unknown clip';
        const client = session.client || `Session ${session.id}`;
        return (
          <option key={session.id} value={session.id}>
            {status} {client} - {clipName} - {siteLabel(session.siteId, siteNames)} - #{session.id} ({startDate})
          </option>
        );
      })}
    </select>
  );
};
